import { useNavigate } from "react-router-dom";
import { FetchActionsResponse } from "../../../types/apiResponsesTypes";
import GenericTable from "../GenericTable";
import useTableActions from "./hooks/useTableActions";
import { ActionPartial } from "../../../types/actions";
import { Card } from "antd";
import { useMemo } from "react";

type Props = {
  actionsData: FetchActionsResponse | ActionPartial[] | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onDelete: (id: number) => void;
  iAmTheAssignedPilote?: boolean;
  dontFetchOnMount?: boolean;
  isColumnForPageEvent?: boolean;
};

const TableActions: React.FC<Props> = ({
  actionsData,
  fetchData,
  isLoading,
  onDelete,
  iAmTheAssignedPilote,
  dontFetchOnMount,
  isColumnForPageEvent,
}) => {
  const navigate = useNavigate();

  // This table is used in both contextes: Dashboard and PageEvent
  const { actions, count } = useMemo(() => {
    const actions = Array.isArray(actionsData)
      ? actionsData
      : actionsData?.results || [];
    const count = Array.isArray(actionsData)
      ? actionsData.length
      : actionsData?.count || 0;

    return { actions, count };
  }, [actionsData]);

  const { columns, onRowClick } = useTableActions({
    navigate,
    onDelete,
    actions,
    iAmTheAssignedPilote,
    isColumnForPageEvent,
  });

  return (
    <Card title="Actions Ã  faire" bordered={false}>
      <GenericTable<ActionPartial>
        results={actions}
        count={count}
        columns={columns}
        fetchData={fetchData}
        isLoading={isLoading}
        onRow={onRowClick}
        direction={["descend"]}
        dontFetchOnMount={dontFetchOnMount}
      />
    </Card>
  );
};

export default TableActions;
